/* eslint-disable */
export default {
  logging: 'Wordt gelogd...',
  logCall: 'Oproep loggen',
  editLog: 'Lijst bewerken',
  select: 'Record select.',
  OnHold: 'In de wacht',
  Ringing: 'Gaat over',
  CallConnected: 'Oproep verbonden',
  unknownUser: 'Onbekende gebruiker',
  unknownNumber: 'Anoniem',
  unavailable: 'Niet beschikbaar',
  viewDetails: 'Details weergeven',
  conferenceCall: 'Conference call',
  callerId: 'Beller-ID',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"callerId"@#@ @source: @#@"Caller ID"@#@
